export const SECTION_IDS = {
  details: 'details',
  inherent: 'inherent',
  residual: 'residual',
  inherentOversight: 'inherentOversight',
  residualOversight: 'residualOversight',
  inherentInternalAudit: 'inherentInternalAudit',
  residualInternalAudit: 'residualInternalAudit',
} as const;

export type SectionId = (typeof SECTION_IDS)[keyof typeof SECTION_IDS];
